// Navigation
import Navigation from './modules/_responsive_sticky_navigation.js';

// Maps - ties in to the Locator plugin
import Maps from './modules/_maps.js';

// Animations
import Animations from './modules/_animations.js';

function init() {
  Navigation.setup();
  Maps.setup();
  Animations.setup();
}

init();

